function reloadVariantSections({ data: { event, target, selectedOptionValues } }) {
  const targets = document.querySelectorAll('.js-reload-on-variant');

  targets.forEach((target) => {
    const sectionId = target.dataset.section;
    // buildSectionUrl drops any section params already present on the current URL
    // before setting the ones this request actually needs.
    const url = buildSectionUrl(window.location.href, {
      option_values: selectedOptionValues.join(','),
      section_id: sectionId
    });

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        const newSection = newDoc.getElementById(`shopify-section-${sectionId}`);

        if (newSection) {
          target.innerHTML = newSection.innerHTML;
        }
      })
      .catch((error) => {
        console.error(`Error loading section ${sectionId}:`, error);
      });
  });
}

subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, reloadVariantSections);
